module.exports = __webpack_public_path__ + "media/target_area_icon/dept_qc-14c2f5a7.png";